/**
 * @generated SignedSource<<91a5e13168a2c7a4e6daa3164794caba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryLabelIndexPageContentInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelsInternal">;
  readonly " $fragmentType": "RepositoryLabelIndexPageContentInternal";
};
export type RepositoryLabelIndexPageContentInternal$key = {
  readonly " $data"?: RepositoryLabelIndexPageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelIndexPageContentInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderDirection"
    },
    {
      "defaultValue": "NAME",
      "kind": "LocalArgument",
      "name": "orderField"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryLabelIndexPageContentInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "orderDirection",
          "variableName": "orderDirection"
        },
        {
          "kind": "Variable",
          "name": "orderField",
          "variableName": "orderField"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RepositoryLabelsInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "cf64a9071b0b4ea2471b3f4ad289bdf5";

export default node;
